
export default {
    api: {
        url: 'https://api.tunisierecyclage.org',
    },
};
